import { ArrowBackIosNew } from '@mui/icons-material'
import { DialogContentText, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import TwoFactorSupportInfo from '../../TwoFactorSupportInfo'
import { BackButton, StepContent } from '../ReauthenticationDialog.style'

interface SupportInfoStepProps {
  onBack: () => void
}

// For users without access to their authenticator app
const SupportInfoStep = ({ onBack }: SupportInfoStepProps) => {
  const { t } = useTranslation()

  return (
    <StepContent sx={{ pb: 3 }}>
      <Stack spacing={2.5}>
        <DialogContentText variant="body2" color="text.secondary">
          {t('reauthentication.supportDescription')}
        </DialogContentText>
        {/* Its Grid relies on negative margins, which Stack would reset */}
        <div>
          <TwoFactorSupportInfo
            backButton={
              <BackButton
                variant="text"
                startIcon={<ArrowBackIosNew />}
                onClick={onBack}
              >
                {t('reauthentication.goBack')}
              </BackButton>
            }
          />
        </div>
      </Stack>
    </StepContent>
  )
}

export default SupportInfoStep
